"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LandingPageSubBlockCtaType;
(function (LandingPageSubBlockCtaType) {
    LandingPageSubBlockCtaType["Redirect"] = "Redirect";
    LandingPageSubBlockCtaType["PopIn"] = "Pop-In";
})(LandingPageSubBlockCtaType = exports.LandingPageSubBlockCtaType || (exports.LandingPageSubBlockCtaType = {}));
var BlockStepsCtaTypes;
(function (BlockStepsCtaTypes) {
    BlockStepsCtaTypes["DOWNLOADABLE"] = "Downloadable";
})(BlockStepsCtaTypes = exports.BlockStepsCtaTypes || (exports.BlockStepsCtaTypes = {}));
//# sourceMappingURL=LandingPages.js.map